import { axios } from '@/plugins/http-axios';
import { Module } from 'vuex';

interface IUser {
  client: string
  surname: string;
  name: string;
  parname: string;
  phone: string;
  email: string;
  agent: string;
}

class User implements IUser {
  client: string;
  surname: string;
  name: string;
  parname: string;
  phone: string;
  email: string;
  agent: string;
  constructor({ client = '', surname = '', name = '', parname = '', phone = '', email = '', agent = '' } = {}) {
    this.client = client;
    this.surname = surname;
    this.name = name;
    this.parname = parname;
    this.phone = phone;
    this.email = email;
    this.agent = agent;
  }
}
interface IUserState {
  user: IUser;
  authorized: string | undefined;
}

export default <Module<IUserState, any>>{
  state: {
    user: new User(),
    authorized: undefined,
  },
  mutations: {
    setAuthorized(state, value = undefined) {
      state.authorized = value;
    },
    setUser(state, data: IUser) {
      state.user = new User(data);
    },
  },
  actions: {
    async getUser({ commit, dispatch, rootGetters }): Promise<string> {
      return axios
        .get<IUser>(rootGetters.uri.user)
        .then((resp) => {
          commit('setAuthorized', 'authorized');
          commit('setUser', resp.data);
          return Promise.resolve('authorized');
        })
        .catch((e) => {
          if ('response' in e && e.response instanceof Object && e.response.status == 403) {
            commit('setAuthorized', 'no_authorized');
            return Promise.resolve('no_authorized');
          }
          e.uri = rootGetters.uri.user;
          dispatch('setError', e);
          return Promise.reject(e);
        });
    },
  },
  getters: {
    user: (state): IUser => state.user,
    isLkkMode: (state): boolean => !!state.user.client,
    isLkpMode: (state): boolean => !state.user.client && !!state.user.agent,
    authorized: (state): string | undefined => state.authorized,
    userPhone: (state): string => state.user.phone.replace(/(.+)(\d{3})(\d{3})(\d{2})(\d{2})$/, '$1 ($2) $3 $4 $5'),
  },
};
